<template>
  <el-config-provider :locale="elementLocale">
    <NetworkStatus @retry-login="handleRetryLogin" />
    <component :is="route.meta.layoutComponent">
      <router-view />
    </component>
    <modals-container />
    <div v-if="loading"
         class="loading-overlay"
    >
      <square-grid />
    </div>
  </el-config-provider>
</template>
<script setup>
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import ru from 'element-plus/es/locale/lang/ru';
import uk from 'element-plus/es/locale/lang/uk';
import en from 'element-plus/es/locale/lang/en';
import es from 'element-plus/es/locale/lang/es';
import pt from 'element-plus/es/locale/lang/pt';
import NetworkStatus from '@/components/UI/NetworkStatus.vue';

import { ModalsContainer, useModal } from 'vue-final-modal';
import Offline from '@/components/UI/modals/Offline.vue';
import { useStore } from 'vuex';

const store = useStore();
const router = useRouter();
const loading = computed(() => store.state.loading.loading);
const { locale } = useI18n({ useScope: 'global' });
const elementLocales = { ru, uk, en, es, pt };
const elementLocale = computed(() => elementLocales[locale.value] || ru);

const route = useRoute();


const handleRetryLogin = () => {
  if (route.name !== 'login') {
    router.push({ name: 'login' });
  }
};

const offlineModal = useModal({
  component: Offline,
  attrs: {
    clickToClose: false,
    escToClose: false,
  },
});
</script>
<style lang="scss" scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}
</style>
